import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_guanyuwomen from '../views/lanhu_guanyuwomen/index.vue'
import lanhu_yuanqujieshao from '../views/lanhu_yuanqujieshao/index.vue'
import lanhu_zaixiangoumu from '../views/lanhu_zaixiangoumu/index.vue'
import lanhu_zaixianjidian from '../views/lanhu_zaixianjidian/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'
import lanhu_muxingzhanshi from '../views/lanhu_muxingzhanshi/index.vue'
import Login from '../views/Login.vue'
import NewsList from '../views/NewsList.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Reserve from '../views/Reserve.vue'
import ProductDetail from '../views/ProductDetail.vue'
import UserCenter from '../views/UserCenter.vue'
import Service from '../views/Service.vue'
import { isLoggedIn } from '@/api/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/lanhu_shouye"
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/lanhu_guanyuwomen',
    name: 'lanhu_guanyuwomen',
    component: lanhu_guanyuwomen
  },
  {
    path: '/lanhu_yuanqujieshao',
    name: 'lanhu_yuanqujieshao',
    component: lanhu_yuanqujieshao
  },
  {
    path: '/lanhu_zaixiangoumu',
    name: 'lanhu_zaixiangoumu',
    component: lanhu_zaixiangoumu
  },
  {
    path: '/lanhu_muxingzhanshi',
    name: 'lanhu_muxingzhanshi',
    component: lanhu_muxingzhanshi
  },
  {
    path: '/lanhu_zaixianjidian',
    name: 'lanhu_zaixianjidian',
    component: lanhu_zaixianjidian,
    meta: { requiresAuth: true } // 需要登录
  },
  {
    path: '/lanhu_shouye',
    name: 'lanhu_shouye',
    component: lanhu_shouye
  },
  {
    path: '/news',
    name: 'NewsList',
    component: NewsList
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/reserve',
    name: 'Reserve',
    component: Reserve
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: UserCenter,
    meta: { requiresAuth: true } // 需要登录
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 检查需要登录的页面
router.beforeEach((to, from, next) => {
  // 如果路由需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn()) {
      // 未登录，跳转到登录页，并保存要访问的页面
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      // 已登录，继续访问
      next()
    }
  } else {
    // 不需要登录的页面，直接访问
    next()
  }
})

export default router
